import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { AddressDetails } from 'src/app/models/onboarding/applicant-address.model';

@Component({
	selector: 'cmv-card-tracking-number',
	templateUrl: './card-tracking-number.component.html',
	styleUrls: ['./card-tracking-number.component.scss'],
})
export class CardTrackingNumberComponent implements OnInit, OnDestroy {
	@Input() trackingNumber: string;
	@Input() address: AddressDetails;
	@Output() closeTrackingNumber: EventEmitter<void> = new EventEmitter();

	constructor() {}

	ngOnDestroy(): void {
		document.body.style.overflow = '';
	}

	ngOnInit(): void {
		setTimeout(() => (document.body.style.overflow = 'hidden'), 500);
	}

	onCloseTrackingNumber(): void {
		this.closeTrackingNumber.emit();
	}
}
